import React, { useContext } from 'react';
import { UserContext } from '../context/UserContext';

const CheckUserContext = () => {
    const { currentUser } = useContext(UserContext);

    if(currentUser) {
        console.log(currentUser)
    }

    return (
        <div>
            <h2>Проверка контекста UserContext</h2>
            {currentUser ? (
                <div>
                    <p>Пользователь авторизован:</p>
                    <p>Имя пользователя: {currentUser.username}</p>
                    <p>Email: {currentUser.email}</p>
                </div>
            ) : (
                <p>Пользователь не авторизован</p>
            )}
        </div>
    );
};

export default CheckUserContext;